angular.module('impactx.search').component('ixProductGroupItem', {
        bindings: {
            productGroup: '<'
        },
        controller: 'ProductGroupItemCtrl',
        controllerAs: 'productGroupItemCtrl',
        templateUrl: 'modules/search/templates/product-group-item.html'
    }
);
